import { FileSystem } from "./adapters/fileSystem";
import { ExportGenerator } from "./adapters/exportGenerator";
import { Repository } from "./adapters/repository";

import * as exportData from "./useCases/exportData";
import * as requestExportBiRun from "./useCases/requestExportBiRun";
import * as retrieveExportBiRun from "./useCases/retrieveExportBiRun";

enum UseCases {
  exportData = "exportData",
  requestExportBiRun = "requestExportBiRun",
  retrieveExportBiRun = "retrieveExportBiRun",
}

interface Core {
  [UseCases.exportData]: exportData.Interactor;
  [UseCases.requestExportBiRun]: requestExportBiRun.Interactor;
  [UseCases.retrieveExportBiRun]: retrieveExportBiRun.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  fileSystem: FileSystem;
  exportGenerator: ExportGenerator;
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.exportData]: exportData.createInteractor(
      dependencies.fileSystem,
      dependencies.exportGenerator,
    ),
    [UseCases.requestExportBiRun]: requestExportBiRun.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveExportBiRun]: retrieveExportBiRun.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
